module.exports = __webpack_public_path__ + "static/media/img_female.dd61301a.svg";